import { FilterV3ContextProvider } from '@components/FilterV3/contexts/FilterV3.context';
import { Stack } from '@mui/material';
import { ListScreenBody } from './components/ListScreenBody';
import { ListScreenFilterBar } from './components/ListScreenFilterBar';
import { ListScreenHeader } from './components/ListScreenHeader';
import { ListScreenToolbar } from './components/ListScreenToolbar';
import { ListScreenContext, ListScreenContextValue } from './contexts/ListScreen.context';
import { useListScreenState } from './hooks/useListScreenState';
import { ListScreenProps } from './listScreen.types';

export function ListScreen({ header, toolbar, filters, scrollRef, children }: ListScreenProps) {
  const { scrollNode, setScrollNode, triggerRef } = useListScreenState();

  const contextValue: ListScreenContextValue = { scrollNode, setScrollNode, triggerRef };

  const content = (
    <ListScreenContext.Provider value={contextValue}>
      <Stack sx={{ height: '100%', minHeight: 0, bgcolor: 'transparent' }}>
        <ListScreenHeader {...header} />
        <ListScreenToolbar {...toolbar} filters={filters} />
        <ListScreenBody
          filterBar={filters ? <ListScreenFilterBar filters={filters} /> : undefined}
          scrollRef={scrollRef}
        >
          {children}
        </ListScreenBody>
      </Stack>
    </ListScreenContext.Provider>
  );

  if (filters) {
    return <FilterV3ContextProvider options={filters.options}>{content}</FilterV3ContextProvider>;
  }

  return content;
}

export default ListScreen;
